export const ATOMIC_AI_AGENT = "atomic" as const;
